import { render } from "./WithoutPrice.vue?vue&type=template&id=47696681"
import script from "./WithoutPrice.vue?vue&type=script&lang=js"
export * from "./WithoutPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__